import { AbcFitnessBrandLogo } from "@/components/portal/AbcFitnessBrandLogo";
import { GlofoxBrandLogo } from "@/components/portal/GlofoxBrandLogo";
import { useBrandHomeRoute } from "@/hooks/useBrandHomeRoute";
import { GLOFOX_DOCS_HOME_ROUTE } from "@/lib/portal/docs-urls";

interface AuthBrandHeaderProps {
  testId?: string;
}

/** Brand block above the auth cards, with the logo linking back to the landing page. */
export function AuthBrandHeader({
  testId = "auth-brand-logo",
}: AuthBrandHeaderProps) {
  const brandHomeRoute = useBrandHomeRoute();

  return (
    <div className="auth-brand">
      <div className="auth-brand__logos">
        <AbcFitnessBrandLogo
          to={brandHomeRoute}
          theme="light"
          testId={testId}
        />
        <span className="auth-brand__separator" aria-hidden>
          /
        </span>
        <GlofoxBrandLogo
          to={GLOFOX_DOCS_HOME_ROUTE}
          testId={`${testId}-glofox`}
        />
      </div>
      <div className="auth-brand__name">ABC Fitness Developer Portal</div>
    </div>
  );
}
